export default {
	GET_RESET_PASSWORD_RESULT: state => state.resetPasswordResult,
    GET_RESET_PASSWORD_ERROR: state => state.resetPasswordError,
}